import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { LanguageProvider } from "@/lib/i18n/LanguageContext";
import App from "./App";
import "./styles/index.css";
// Get the root element
const container = document.getElementById("root");
if (!container) {
    throw new Error("Root element not found");
}
// Create root and render
const root = createRoot(container);
// Main App Component with React Router future flags
function Root() {
    return (_jsx(Router, { future: {
            v7_startTransition: true,
            v7_relativeSplatPath: true,
        }, children: _jsx(LanguageProvider, { children: _jsx(App, {}) }) }));
}
root.render(_jsx(Root, {}));
